import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";
import "../css/Login.css";

// icons
import googleIcon from "../assets/icons/google.png";
import viewIcon from "../assets/icons/view.png";
import hideIcon from "../assets/icons/hide.png";

export default function Signup() {
  const { signup, loading, error } = useAuth();
  const navigate = useNavigate();
  
  const [form, setForm] = useState({
  name: "",
  email: "",
  username: "",
  phone: "",
  role: "",
  password: "",
  confirmPassword: ""
});

  const [localError, setLocalError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [strength, setStrength] = useState("");

  // 🔐 Password strength logic
  const checkStrength = (password) => {
    if (password.length < 6) return "Weak";
    if (password.match(/^(?=.*[A-Z])(?=.*[0-9]).{6,}$/)) return "Medium";
    if (password.match(/^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$/)) return "Strong";
    return "Weak";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({ ...form, [name]: value });

    if (name === "password") {
      setStrength(checkStrength(value));
    }
  };

  // ✅ Validation
  const validate = () => {
  if (!form.email.includes("@")) return "Invalid email";
  if (!form.username) return "Username required";
  if (form.phone.length < 10) return "Phone must be at least 10 digits";
  if (!form.role) return "Please select a role";
  if (form.password.length < 6) return "Password must be at least 6 characters";
  if (form.password !== form.confirmPassword) return "Passwords do not match";
  return null;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError("");

    const validationError = validate();
    if (validationError) {
      return setLocalError(validationError);
    }

    const data = await signup(form);

    if (data) {
      navigate("/verify-otp", {
        state: {
          user_id: data.user_id,
          role: data.role
        }
      });
    }
  };

  // 🌐 Social signup
  const handleSocialSignup = (provider) => {
  if (!form.role) {
    setLocalError("Please select a role before continuing");
    return;
  }

  // pass role to backend
  const base = process.env.REACT_APP_API_BASE?.replace("/handlers", "") || "https://beintelli.engaggio.com";
  window.location.href = `${base}/handlers/auth/${provider}?role=${form.role}`;
};

  return (
    <div className="login-wrapper">
      <div className="login-main">

        {/* LEFT */}
        <div className="login-left">
          <h2>Create Account</h2>
          <p className="login-aidora-text">
            Join us and unlock powerful insights.
          </p>
        </div>

        {/* RIGHT */}
        <motion.div
          className="login-right"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <form className="login-card" onSubmit={handleSubmit}>
            <h2>Sign Up</h2>

            {(error || localError) && (
              <div className="login-error">{error || localError}</div>
            )}

            {/* Name */}
            <div className="login-floating-field">
              <input placeholder=" " name="name" value={form.name} onChange={handleChange} required />
              <label>Full Name</label>
            </div>

            {/* Email */}
            <div className="login-floating-field">
              <input type="email" placeholder=" " name="email" value={form.email} onChange={handleChange} required />
              <label>Email</label>
            </div>

            {/* Phone */}
            <div className="login-floating-field">
              <input type="tel" placeholder=" " name="phone" value={form.phone} onChange={handleChange} required />
              <label>Phone Number</label>
            </div>

            {/* Username */}
<div className="login-floating-field">
  <input
    type="text"
    placeholder=" "
    name="username"
    value={form.username}
    onChange={handleChange}
    required
  />
  <label>Username</label>
</div>
<p className="role-label">Select Role</p>
<div className="role-toggle">
  {[
    { label: "Parent", value: "parent" },
    { label: "Child", value: "learner" },
    { label: "Educator", value: "educator" },
    { label: "Institution", value: "institution" },
  ].map(({ label, value }) => (
    <button
      key={value}
      type="button"
      className={form.role === value ? "active" : ""}
      onClick={() => setForm({ ...form, role: value })}
    >
      {label}
    </button>
  ))}
</div>

            {/* Password */}
            <div className="login-floating-field">
              <input
                type={showPassword ? "text" : "password"}
                placeholder=" "
                name="password"
                value={form.password}
                onChange={handleChange}
                required
              />
              <label>Password</label>

              <span
  className="toggle-password"
  onClick={() => setShowPassword(!showPassword)}
>
  <img
    src={showPassword ? viewIcon : hideIcon}
    alt="toggle password"
  />
</span>
            </div>

            {/* Strength */}
            {form.password && (
              <div className={`password-strength ${strength.toLowerCase()}`}>
                Strength: {strength}
              </div>
            )}

            {/* Confirm Password */}
            <div className="login-floating-field">
              <input
                type={showPassword ? "text" : "password"}
                placeholder=" "
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                required
              />
              <label>Confirm Password</label>
            </div>

            {/* Submit */}
            <button className="login-button" disabled={loading}>
              {loading ? "Creating..." : "Sign Up"}
            </button>

            {/* Back */}
            <button
              type="button"
              className="login-signup-button"
              onClick={() => navigate("/")}
            >
              Already have an account? Login
            </button>

            {/* Divider */}
            <div className="login-divider">
              <span>or sign up with</span>
            </div>

            {/* Social */}
            <div className="social-login-row">
              <button className="social-btn" type="button" onClick={() => handleSocialSignup("google")}>
                <img src={googleIcon} alt="" /> Google
              </button>

            </div>
          </form>
        </motion.div>
      </div>
    </div>
  );
}